module.exports = __webpack_public_path__ + "static/img/20231220_04.d2e1d6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2023/20231220_04.png
// module id = r/hN
// module chunks = 0